// extracted by mini-css-extract-plugin
export default {"AdminReportingPage":"AdminReportingPage_AdminReportingPage__d1fuA","titleBar":"AdminReportingPage_titleBar__b7BvW"};